// PrivateRoute.js
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { logoutSuccess } from "./redux/reducer/AuthReducer";
import { isTokenValid } from "./utils/tokenHelper";

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();

  // Redux first
  const loginResponse = useSelector((state) => state.AuthReducer?.loginResponse);

  // LocalStorage fallback
  const storedAuth = localStorage.getItem("auth");
  const auth = loginResponse || (storedAuth && JSON.parse(storedAuth));
  const token = auth?.data?.session?.access_token;

  useEffect(() => {
    if (!token) return;

    // validate token with helper
    if (!isTokenValid(token)) {
      dispatch(logoutSuccess());
    }
  }, [token, dispatch]);

  // If no valid token → redirect to login
  if (!token || !isTokenValid(token)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
